module.exports = __webpack_public_path__ + "img/bar_BAK.261375bd.png";